import React from 'react';
import PropTypes from 'prop-types';
import { Link, useNavigate, useLocation } from 'react-router-dom';


Footer.propTypes = {
    
};

function Footer(props) {
    const navigate = useNavigate();
    const location = useLocation();

    const handleAboutClick = (e) => {
        e.preventDefault();
        if (location.pathname === '/') {
            // If already on home page, scroll to section
            const section = document.getElementById('what-is-talsolution');
            if (section) {
                section.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        } else {
            // If on another page, navigate to home and then scroll
            navigate('/');
            setTimeout(() => {
                const section = document.getElementById('what-is-talsolution');
                if (section) {
                    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 200);
        }
    };

    const handleContactClick = (e) => {
        e.preventDefault();
        if (location.pathname === '/') {
            // If already on home page, scroll to section
            const section = document.getElementById('contact-section');
            if (section) {
                section.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        } else {
            // If on another page, navigate to home and then scroll
            navigate('/');
            setTimeout(() => {
                const section = document.getElementById('contact-section');
                if (section) {
                    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 200);
        }
    };

    return (
        <footer className="footer">
                <div className="top-footer">
                <div className="tf-container">
                    <div className="row">
                    <div className="col-lg-2 col-md-4">
                        <div className="footer-logo">
                        <img src={require ('../../assets/images/logo.png')} alt="images" />
                        </div>
                    </div>
                    <div className="col-lg-10 col-md-8">
                        <div className="wd-social d-flex aln-center">
                        <span>Follow Us:</span>
                        <ul className="list-social d-flex aln-center">
                            <li><Link to="#"><i className="icon-facebook"></i></Link></li>
                            <li><Link to="#"><i className="icon-linkedin2"></i></Link></li>
                            <li><Link to="#"><i className="icon-twitter"></i></Link></li>
                            <li><Link to="#"><i className="icon-pinterest"></i></Link></li>
                            <li><Link to="#"><i className="icon-instagram1"></i></Link></li>
                            <li><Link to="#"><i className="icon-youtube"></i></Link></li>
                        </ul>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
                <div className="inner-footer">
                <div className="tf-container">
                    <div className="row">
                    <div className="col-lg-4 col-md-6">
                        <div className="footer-cl-1">
                        <div className="icon-infor d-flex aln-center">
                            <div className="icon">
                            <span className="icon-call-calling"><span className="path1"></span><span className="path2"></span><span
                                className="path3"></span><span className="path4"></span></span>
                            </div>
                            <div className="content">
                            <p>Need help? 24/7</p>
                            <h6><Link to="tel:+12108302282">+1 (210) 830-2282</Link></h6>
                            </div>
                        </div>
                        <p>Connect global talent with US opportunities. Talsolution is a free hiring platform where US companies connect with skilled global professionals.</p>
                        <div className="ft-icon"> <i className="icon-map-pin"></i> 2821 Mexico Gravel Rd #5 Columbia MO 65202</div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-6">
                        <div className="footer-cl-2">
                        <h6 className="ft-title">
                            Quick Links
                        </h6>
                        <ul className="navigation-menu-footer">
                            <li> <Link to="/">Home</Link> </li>
                            <li> <Link to="/careers">Browse Jobs</Link> </li>
                            <li> <Link to="/" onClick={handleAboutClick}>About Us</Link> </li>
                            <li> <Link to="/" onClick={handleContactClick}>Contact Us</Link> </li>
                        </ul>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-6">
                        <div className="footer-cl-3">
                        <h6 className="ft-title">
                            For Candidates
                        </h6>
                        <ul className="navigation-menu-footer">
                            <li> <Link to="/careers">Search Jobs</Link> </li>
                            <li> <Link to="/careers">Tech Roles</Link> </li>
                            <li> <Link to="/careers">Remote Opportunities</Link> </li>
                            <li> <Link to="/careers">Virtual Assistant Roles</Link> </li>
                        </ul>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-6 col-6">
                        <div className="footer-cl-4">
                        <h6 className="ft-title">
                            Legal
                        </h6>
                        <ul className="navigation-menu-footer">
                            <li> <Link to="/termsofuse">Terms of Service</Link> </li>
                            <li> <Link to="/privacypolicy">Privacy Policy</Link> </li>
                            <li> <Link to="/cookiepolicy">Cookie Policy</Link> </li>
                        </ul>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
                <div className="bottom">
                <div className="tf-container">
                    <div className="row">
                    <div className="col-lg-6 col-md-6">
                        <div className="bt-left">
                        <div className="copyright">©{new Date().getFullYear()} Talsolution. All Rights Reserved.</div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <ul className="menu-bottom d-flex aln-center">
                        <li><Link to="/termsofuse">Terms Of Services</Link> </li>
                        <li><Link to="/privacypolicy">Privacy Policy</Link> </li>
                        <li><Link to="/cookiepolicy">Cookie Policy</Link> </li>
                        </ul>
                    </div>
                    </div>
                </div>
                </div>
            </footer>
    );
}

export default Footer;